// Step titles for the booking stepper
export const STEP_TITLES = [
  "Contact & Address",
  "Property Details",
  "Select Date & Time",
  "Confirm Booking",
];

// House type options for property details
export const HOUSE_TYPE_OPTIONS = [
  { value: "single_family", label: "Single Family" },
  { value: "condo", label: "Condo" },
  { value: "townhouse", label: "Townhouse" },
  { value: "manufactured", label: "Manufactured" },
  { value: "multi_family", label: "Multi-Family" },
  { value: "apartment", label: "Apartment" },
  { value: "unknown", label: "Not sure/Unknown" },
];
